import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

function ConsentModal({ accessToken, version, onConsent, onDecline }) {
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const policyId = process.env.REACT_APP_IUBENDA_POLICY_ID;

    const handleSubmit = async () => {
        setLoading(true);
        setError(null);

        try {
            const resp = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/consent`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ version })
            });

            if (!resp.ok) {
                setError('Unable to record consent. Please try again.');
                setLoading(false);
                return;
            }

            onConsent();
        } catch (err) {
            setError('Unable to record consent. Please try again.');
            setLoading(false);
        }
    };

    return (
        <Modal show={true} backdrop="static" keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>Policies Updated</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>We've updated our policies. Please review before continuing:</p>
                <ul>
                    <li>
                        <a
                            href={`https://www.iubenda.com/privacy-policy/${policyId}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Privacy Policy
                        </a>
                    </li>
                    <li>
                        <a
                            href={`https://www.iubenda.com/terms-and-conditions/${policyId}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Terms of Service
                        </a>
                    </li>
                </ul>
                <Form.Check
                    type="checkbox"
                    id="consent-checkbox"
                    label="I have read and consent to the Privacy Policy and Terms of Service as presented."
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                />
                {error && <p className="text-danger mt-2 mb-0">{error}</p>}
            </Modal.Body>
            <Modal.Footer className="flex-column align-items-stretch">
                <p className="text-muted small mb-3">
                    You must consent to our updated policies for continued access to Workspace. Clicking decline will log you out.
                </p>
                <div className="d-flex justify-content-end gap-2">
                <Button
                    variant="outline-secondary"
                    disabled={loading}
                    onClick={onDecline}
                >
                    Decline
                </Button>
                <Button
                    variant="primary"
                    disabled={!checked || loading}
                    onClick={handleSubmit}
                >
                    {loading ? 'Saving...' : 'Continue'}
                </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default ConsentModal;
